enum RECONCILIATION_TYPES {
  UPDATE_RECONCILIATION_COLUMN_FILTERS = 'UPDATE_RECONCILIATION_COLUMN_FILTERS',
  DOWNLOAD_RECONCILIATION_FILE = 'DOWNLOAD_RECONCILIATION_FILE',
  GET_RECONCILIATION_DATA = 'GET_RECONCILIATION_DATA',
  SET_RECONCILIATION_DATA = 'SET_RECONCILIATION_DATA',
  SET_RECONCILIATION_INSURER_FILTER = 'SET_RECONCILIATION_INSURER_FILTER',
  SET_RECONCILIATION_TPA_FILTER = 'SET_RECONCILIATION_TPA_FILTER',
  SET_RECONCILIATION_CENTER_FILTER = 'SET_RECONCILIATION_CENTER_FILTER',
  SET_RECONCILIATION_DOD_FILTER = 'SET_RECONCILIATION_DOD_FILTER',
  SET_RECONCILIATION_UTR_DATE_FILTER = 'SET_RECONCILIATION_UTR_DATE_FILTER',
  SET_RECONCILIATION_UTR_NUMBER_FILTER = 'SET_RECONCILIATION_UTR_NUMBER_FILTER',
  SET_RECONCILIATION_SEARCH_FILTER = 'SET_RECONCILIATION_SEARCH_FILTER',
  SET_RECONCILIATION_SORTING_KEY = 'SET_RECONCILIATION_SORTING_KEY',
  SET_RECONCILIATION_CLAIM_STATUSES = 'SET_RECONCILIATION_CLAIM_STATUSES',
  SET_RECONCILIATION_START_INDEX = 'SET_RECONCILIATION_START_INDEX',
  SET_RECONCILIATION_PAGE_RANGE = 'SET_RECONCILIATION_PAGE_RANGE',
  SET_IS_TABLE_LOADING = 'SET_IS_TABLE_LOADING',
  GET_INSURER_WISE_TDS_RATES = 'GET_INSURER_WISE_TDS_RATES',
  SET_INSURER_WISE_TDS_RATES = 'SET_INSURER_WISE_TDS_RATES',
  SET_IS_TDS_EDITABLE= 'SET_IS_TDS_EDITABLE',
  UPDATE_INSURER_WISE_TDS_RATES= 'UPDATE_INSURER_WISE_TDS_RATES',
  SET_RECONCILIATION_VIEW_ID = 'SET_RECONCILIATION_VIEW_ID',
  SET_IS_RECONCILIATION_EDITABLE = 'SET_IS_RECONCILIATION_EDITABLE',
  UPDATE_RECONCILIATION_DATA = 'UPDATE_RECONCILIATION_DATA',
  UPDATED_RECONCILIATION_COLS_DATA = 'UPDATED_RECONCILIATION_COLS_DATA',
  SET_RECONCILIATION_CLAIM_DETAIL = 'SET_RECONCILIATION_CLAIM_DETAIL',
  GET_RECONCILIATION_DETAIL = 'GET_RECONCILIATION_DETAIL',
  SET_RECONCILIATION_DETAIL = 'SET_RECONCILIATION_DETAIL',
  SET_AUDIT_TRAIL_DETAIL = 'SET_AUDIT_TRAIL_DETAIL',
}

export default RECONCILIATION_TYPES;
